import * as React from 'react';
import {Button, ButtonGroup, Col} from 'reactstrap';
import renderDatePickerField from '../../../theme/components/form/DatePicker';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import validate from './validate';
import * as moment from 'moment';
import Panel from '../../../theme/components/Panel';

class LiquidacionForm extends React.PureComponent<InjectedFormProps> {

    public render() {
        const {handleSubmit} = this.props;
        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <Col md={12}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Fecha</label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='fecha'
                                    component={renderDatePickerField}
                                    filterDate={(date) => {
                                        return moment() > date;
                                    }}
                                    defaultDate={moment()}
                                    placeholder='dd/mm/yyyy'
                                />
                                <div className='form__form-group-icon'>
                                    <CalendarBlankIcon/>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'liquidacion_form', // a unique identifier for this form
    validate,
})(LiquidacionForm);


// WEBPACK FOOTER //
// ./src/components/pages/liquidacion/liquidacion-form.tsx